<script>
import { Radar, mixins } from 'vue-chartjs';

export default {
  extends: Radar,
  mixins: [mixins.reactiveProp],
  props: {
    options: { type: Object, default: () => ({}) },
  },
  computed: {
    chartOptions() {
      return {
        ...this.options
      };
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};

</script>
